import styled, { css } from 'styled-components'
import { Header, Footer, NavPanel, ScrollBtn, ContactWidget } from '@/components'

export default function Page({ children, menu, ...props }) {
  const isDoctor = props.first_name && props.last_name;
  const isContacts = props.pageType == 'contacts';

  return (
    <StyledPage >
      <Header menu={menu} />
      <NavPanel menu={menu} />
      <StyledContent hide={isContacts}>{children}</StyledContent>
    <Footer menu={menu} isTop={!isDoctor} stretch={isContacts} large={isContacts} />
      <ScrollBtn />
      <ContactWidget />
    </StyledPage>
  )
}

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  min-width: 320px;
`

const StyledContent = styled.main`
  flex: 1 0 auto;
  display:flex;
  flex-direction:column;
  width:100%;
  ${(props) =>
    props.hide  &&
    css`
      display:none;
    `}
`
